import { createContext, useContext, useMemo } from "react"

import { useDateTime } from "../../../../../../modules/localization/useDateTime"
import { MeetingServiceOrder } from "../../../../../../modules/merchant/accounting/accounting/accountingTypes"

import { buildInitialRefundQuantitiesFromOrderDetails } from "./helpers"

const RefundSnapshotContext = createContext<Record<string, number>>({})

type RefundSnapshotProviderProps = Readonly<{
    orderDetails?: MeetingServiceOrder
    children: React.ReactNode
}>

export function RefundSnapshotProvider({ orderDetails, children }: RefundSnapshotProviderProps): React.ReactElement {
    const dateTimeFactory = useDateTime()
    const snapshot = useMemo(
        () => buildInitialRefundQuantitiesFromOrderDetails(orderDetails, dateTimeFactory),
        [orderDetails, dateTimeFactory],
    )
    return <RefundSnapshotContext.Provider value={snapshot}>{children}</RefundSnapshotContext.Provider>
}

export function useRefundSnapshot(): Record<string, number> {
    return useContext(RefundSnapshotContext)
}
